import { Theme } from '@mui/material';
import { OverridesStyleRules } from '@mui/material/styles/overrides';

export const MUI_TAB_OVERRIDES: Partial<
  OverridesStyleRules<
    | 'root'
    | 'labelIcon'
    | 'textColorInherit'
    | 'textColorPrimary'
    | 'textColorSecondary'
    | 'selected'
    | 'disabled'
    | 'fullWidth'
    | 'wrapped'
    | 'iconWrapper',
    'MuiTab',
    Omit<Theme, 'components'>
  >
> = {
  root: ({ theme }) => ({
    minWidth: theme.spacing(7),
    alignItems: 'center',
    textTransform: 'uppercase',
    flexFlow: 'column nowrap',
    flex: '0 0 auto',
    justifyContent: 'center',
    cursor: 'pointer',
    position: 'relative',
    userSelect: 'none',
    height: '100%',
    padding: theme.spacing(0),
    marginRight: theme.spacing(3.75),
    fontSize: theme.spacing(1.75),

    '&:hover': {
      color: theme.palette.text.primary,
    },

    '&.Mui-selected': {
      color: theme.palette.text.primary,
    },
  }),
};
